exports.BusinessObject = [
  {
    id: "id",
    name: "id",
    type: "text",
    value: "",
    label: "Id",
    length: 12,
    key: "true",
  },
  {
    id: "universalDescriptor",
    name: "universalDescriptor",
    type: "text",
    value: "",
    label: "Universal Descriptor",
    length: 50,
  },

  {
    id: "businessObjectCategoryId",
    name: "businessObjectCategoryId",
    type: "text",
    value: "",
    label: "Category",
    ddid: "businessObjectCategoryId",
  },

  {
    id: "implementationId",
    name: "implementationId",
    type: "text",
    value: "",
    label: "Impl",
    ddid: "implementationId",
  },
  {
    id: "itemIncrement",
    name: "itemIncrement",
    type: "number",
    value: "",
    label: "Item Increment",
  },
  {
    id: "subItemIncrement",
    name: "subItemIncrement",
    type: "number",
    value: "",
    label: "Sub Item Increment",
  },

  {
    id: "nameLocalizedText",
    name: "nameLocalizedText",
    type: "text",
    value: "",
    label: "nameLocalizedText",
  },

  {
    id: "createdBy",
    name: "createdBy",
    type: "text",
    label: "Created By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "createdOn",
    name: "createdOn",
    type: "datetime",
    label: "Created On",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedBy",
    name: "modifiedBy",
    type: "text",
    label: "Modified By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedOn",
    name: "modifiedOn",
    type: "datetime",
    label: "ModifiedOn",
    displayonly: "true",
    value: " ",
  },
];
